/** MSAL setup for Entra ID sign-in. */

import { LogLevel, PublicClientApplication, type Configuration } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;

export const API_SCOPE = import.meta.env.VITE_API_SCOPE;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    // Single-tenant: only people in the organisation's directory can even reach the
    // sign-in screen, and the API then checks they have been invited.
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // sessionStorage keeps the token out of other tabs and clears it when the browser
    // closes, which suits a shared-link internal tool better than localStorage.
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      loggerCallback: (_level, message, containsPii) => {
        if (!containsPii) console.error(message);
      },
    },
  },
};

/** The scope the SPA asks for when calling its own API. */
export const apiTokenRequest = { scopes: [API_SCOPE] };

export const msalInstance = new PublicClientApplication(msalConfig);
